import { render, staticRenderFns } from "./TableRoleUpdater.vue?vue&type=template&id=13c1b3c8&scoped=true"
import script from "./TableRoleUpdater.vue?vue&type=script&lang=js"
export * from "./TableRoleUpdater.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c1b3c8",
  null
  
)

export default component.exports